import { RouteRecordRaw } from 'vue-router';
import * as CONST from '@/const'

let routes: RouteRecordRaw[] = [
    {
        path: '/commesse',
        name: 'commesse',
        component: () => import("./views/commesse.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.User]
        }
    },
    {
        path: '/commesse/:identifier',
        name: 'commessaDetail',
        component: () => import("./views/commessaDetail.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.User],
            hideHelpButton: true
        }
    },
];

export default routes;
